import {
    FUTURE_DATE_LIMIT,
    PAST_DATE_LIMIT,
} from '@/components/common/Filter/TimelineFilter/constants'
import { ReportFiltersValues } from '@/features/Analytics/stores/useAnalyticsFiltersStore/types'
import { CustomReportFiltersParams } from '@/hooks'
import { formatLocalDateForTimeline } from '@/utils/date'
import { TimelineFilterValue } from '@/components/common/Filter/types'

export const mapParamsToFilters: (
    params: CustomReportFiltersParams
) => ReportFiltersValues = (params) => {
    const filters: ReportFiltersValues = {
        node: params.nodeIds,
        commodity:
            params.commodityTypeIds ??
            (params.commodityTypeId ? [params.commodityTypeId] : []),
        provider: params.providerIds ?? [],
        contract: params.contractIds ?? [],
        account: params.panIds ?? [],
        tag: params.tagIds ?? [],
        facility: params.facilityIds ?? [],
        meter: params.meterIds ?? [],
        usn: params.usnAccountIds ?? [],
        calculation: 'productionMonth',
        invoiceNo: params.invoiceNumbers ?? [],
        timeline: getTimelineFilterValue(params),
        unitOfMeasureId: params.unitOfMeasureId ? [params.unitOfMeasureId] : [],
    }
    return filters
}

function getTimelineFilterValue(
    params: CustomReportFiltersParams
): TimelineFilterValue {
    if ('startDate' in params && 'endDate' in params) {
        if (params.startDate === formatLocalDateForTimeline(PAST_DATE_LIMIT)) {
            return {
                type: 'isBefore',
                value: {
                    startDate: params.startDate,
                    endDate: params.endDate,
                },
            }
        }
        if (params.endDate === formatLocalDateForTimeline(FUTURE_DATE_LIMIT)) {
            return {
                type: 'isAfter',
                value: {
                    startDate: params.startDate,
                    endDate: params.endDate,
                },
            }
        }
        return {
            type: 'isBetween',
            value: {
                startDate: params.startDate,
                endDate: params.endDate,
            },
        }
    }

    return {
        type: 'is',
        value: params.timeline,
    }
}
